import { updateVision as _updateVision } from '@griply/services';
import { doc, serverTimestamp, Timestamp, updateDoc } from 'firebase/firestore';
import { UpdateVision } from 'shared/types/vision';

import { getDatabase } from './helpers';

export const updateVision = async (vision: UpdateVision): Promise<void> => {
  await _updateVision({
    vision,
    doc,
    updateDoc,
    db: getDatabase(),
    timestampFromDate: (date: Date) => Timestamp.fromDate(date),
    serverTimestamp,
  });
};
